export const WA_NUMBER_DISPLAY = "(12) 99158-5071";
export const WA_NUMBER = "5512991585071";

export const wa = (message) =>
    message
        ? `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`
        : `https://wa.me/${WA_NUMBER}`;

export const WA_HERO =
    "https://wa.me/5512991585071?text=Ol%C3%A1!%20Conheci%20a%20SETH%20pelo%20site%20e%20gostaria%20de%20entender%20como%20voc%C3%AAs%20podem%20ajudar%20meu%20neg%C3%B3cio.";

export const WA_FINAL =
    "https://wa.me/5512991585071?text=Ol%C3%A1!%20Conheci%20a%20SETH%20e%20gostaria%20de%20conversar%20sobre%20uma%20solu%C3%A7%C3%A3o%20para%20o%20meu%20neg%C3%B3cio.";

export const WA_HOSPITALITY = wa(
    "Olá! Tenho um negócio de hotelaria e gostaria de conversar sobre uma solução da SETH."
);

export const NAV = [
    { label: "Início", href: "#inicio" },
    { label: "Soluções", href: "#solucoes" },
    { label: "Como funciona", href: "#como-funciona" },
    { label: "Para quem é", href: "#para-quem" },
    { label: "Sobre a SETH", href: "#sobre" },
    { label: "FAQ", href: "#faq" },
];
